import React from 'react';
import { formatPrice } from '../../AppUtils.js';

const MobileFooter = ({
  selectedProducts,
  totalPrice,
  showHintArrow,
  onDismissHint,
  onShowBuildSummary
}) => (
  <div className="lg:hidden relative flex-shrink-0">
    {showHintArrow && (
      <div className="absolute -top-12 left-8 z-50">
        <div className="relative">
          <div className="bg-yellow-400 text-black px-3 py-1.5 pr-8 rounded-full text-sm font-medium shadow-lg animate-bounce whitespace-nowrap">
            Click here to see your build!
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDismissHint();
              }}
              className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center hover:bg-black/10 rounded-full transition-colors"
              aria-label="Dismiss hint"
            >
              <span className="text-black font-bold text-xs">✕</span>
            </button>
          </div>
          <div className="absolute top-full left-6 w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px] border-l-transparent border-r-transparent border-t-yellow-400"></div>
        </div>
      </div>
    )}

    <div className="bg-black p-4">
      <div
        onClick={onShowBuildSummary}
        className="cursor-pointer"
      >
        <div className="flex justify-between items-center text-white gap-3">
          <img
            src="/logo.svg"
            alt="Vesaro"
            className="h-8 w-8 flex-shrink-0"
          />
          <div className="text-left flex-1">
            <div className="text-sm font-medium">View Build</div>
            <div className="text-xs opacity-75">{Object.keys(selectedProducts).length} items</div>
          </div>
          <div className="text-right">
            <div className="text-xs opacity-75">Total:</div>
            <div className="text-lg font-bold">{formatPrice(totalPrice)}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default MobileFooter;
